import { CollectionData } from "./collections";
import { getCollectionImageUrl } from "@/lib/cloudinary";

export const splashDescriptionParagraphs = [
  "Splash s'inspire des profondeurs aquatiques, combinant textures fluides et nuances océaniques. Chaque look évoque la fraîcheur et la puissance de l'eau, traduisant une esthétique futuriste et audacieuse.",
  "Les silhouettes épurées et les matières translucides rappellent le mouvement des vagues, tandis que des détails métalliques ajoutent une touche d'avant-garde. La collection reflète une fusion entre nature et modernité.",
  "Avec Splash, l'élégance plonge dans un univers aquatique, capturant l'essence de la fluidité et de l'énergie en constante transformation. Une véritable immersion dans un luxe innovant et vibrant.",
];

export const splashCollection: CollectionData = {
  id: "2022-splash",
  title: "Collection Splash",
  descriptionParagraphs: splashDescriptionParagraphs,
  images: [
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-01"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-02"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-03"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-04"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-05"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-06"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-07"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-08"),
    // missing 09
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-10"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-11"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-12"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-13"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-14"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-15"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-16"),
    getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-17"),
  ],
  date: "03/22",
  bannerImage: getCollectionImageUrl("2022-splash", "ALEXANDRA-GREY-SPLASH-01"),
};
